// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".itemno-input[data-v-f16f3826] {\n  min-width: 2.5em;\n}\n.itemdesc-input[data-v-f16f3826] {\n  min-width: 20em;\n}\n.money-input[data-v-f16f3826] {\n  max-width: 50px;\n}", ""]);
// Exports
module.exports = exports;
